// One extra screen of real cards on every side. A normal pan stays inside cards
// that are already mounted, so the drag does not have to create them.
// Hysteresis: cards already loaded stay until they clear this further band,
// which avoids mount/unmount flicker on the boundary.
export const VIEWPORT_PADDING_RATIO = 1;
export const VIEWPORT_HYSTERESIS_EXTRA = 0.55;
// Same reach as the mount band. The extra screen is full mission cards.
export const SCREEN_CARD_PADDING_RATIO = 1;
// Wires are kept when their endpoint box crosses this band.
export const EDGE_CULL_PADDING_RATIO = 0.05;
// How many off-screen silhouettes become full cards per frame after a pan settles.
export const FULL_MOUNT_BATCH = 4;
// During a live pan, mount this many newcomers per catch-up. The pan frame itself mounts none.
export const LIVE_MOUNT_BATCH = 1;
// Wait this long after a pan frame before mounting the next card, so the transform can paint.
export const PAN_CATCHUP_MS = 50;

// Throttle for non-pan paths (resize, task changes)
export const VISIBILITY_UPDATE_THROTTLE = 32;
// Cull and finish promoting after the last panupdate. The drag itself does not remount cards.
export const PAN_CULL_IDLE_MS = 100;
